export const enum TransmitStatus {
    Pending = 'PENDING',
    Sent = 'SENT',
    Delivered = 'DELIVERED',
    Read = 'READ',
    Error = 'ERROR',
}
